import Vue from 'vue'
import Router from 'vue-router'
//404
const empty = resolve => {
  require.ensure(['@/page/empty.vue'], () => {
    resolve(require('@/page/empty.vue'))
  })
}
//1.首页
const index = resolve => {
  require.ensure(['@/page/index.vue'], () => {
    resolve(require('@/page/index.vue'))
  })
}
const index_im = resolve => {
  require.ensure(['@/page/index_im.vue'], () => {
    resolve(require('@/page/index_im.vue'))
  })
}
const index_ws = resolve => {
  require.ensure(['@/page/index_ws.vue'], () => {
    resolve(require('@/page/index_ws.vue'))
  })
}
const index_sn = resolve => {
  require.ensure(['@/page/index_sn.vue'], () => {
    resolve(require('@/page/index_sn.vue'))
  })
}
const index_asus = resolve => {
  require.ensure(['@/page/index_asus.vue'], () => {
    resolve(require('@/page/index_asus.vue'))
  })
}
const index_cino = resolve => {
  require.ensure(['@/page/index_cino.vue'], () => {
    resolve(require('@/page/index_cino.vue'))
  })
}
const index_cino_im = resolve => {
  require.ensure(['@/page/index_cino_im.vue'], () => {
    resolve(require('@/page/index_cino_im.vue'))
  })
}
const index_cino_ws = resolve => {
  require.ensure(['@/page/index_cino_ws.vue'], () => {
    resolve(require('@/page/index_cino_ws.vue'))
  })
}
//2.选择方式
const select = resolve => {
  require.ensure(['@/page/select.vue'], () => {
    resolve(require('@/page/select.vue'))
  })
}
const select_im = resolve => {
  require.ensure(['@/page/select_im.vue'], () => {
    resolve(require('@/page/select_im.vue'))
  })
}
const select_ws = resolve => {
  require.ensure(['@/page/select_ws.vue'], () => {
    resolve(require('@/page/select_ws.vue'))
  })
}

const select_sn = resolve => {
  require.ensure(['@/page/select_sn.vue'], () => {
    resolve(require('@/page/select_sn.vue'))
  })
}
const select_asus = resolve => {
  require.ensure(['@/page/select_asus.vue'], () => {
    resolve(require('@/page/select_asus.vue'))
  })
}
const select_cino = resolve => {
  require.ensure(['@/page/select_cino.vue'], () => {
    resolve(require('@/page/select_cino.vue'))
  })
}
const select_cino_im = resolve => {
  require.ensure(['@/page/select_cino_im.vue'], () => {
    resolve(require('@/page/select_cino_im.vue'))
  })
}
const select_cino_ws = resolve => {
  require.ensure(['@/page/select_cino_ws.vue'], () => {
    resolve(require('@/page/select_cino_ws.vue'))
  })
}
//3.资源分组页面
const library_group = resolve => {
  require.ensure(['@/page/library_group.vue'], () => {
    resolve(require('@/page/library_group.vue'))
  })
}
const library_group_im = resolve => {
  require.ensure(['@/page/library_group_im.vue'], () => {
    resolve(require('@/page/library_group_im.vue'))
  })
}
const library_group_ws = resolve => {
  require.ensure(['@/page/library_group_ws.vue'], () => {
    resolve(require('@/page/library_group_ws.vue'))
  })
}
const library_group_cino = resolve => {
  require.ensure(['@/page/library_group_cino.vue'], () => {
    resolve(require('@/page/library_group_cino.vue'))
  })
}
const library_group_cino_im = resolve => {
  require.ensure(['@/page/library_group_cino_im.vue'], () => {
    resolve(require('@/page/library_group_cino_im.vue'))
  })
}
const library_group_cino_ws = resolve => {
  require.ensure(['@/page/library_group_cino_ws.vue'], () => {
    resolve(require('@/page/library_group_cino_ws.vue'))
  })
}
const library_group_asus= resolve => {
  require.ensure(['@/page/library_group_asus.vue'], () => {
    resolve(require('@/page/library_group_asus.vue'))
  })
}
//4.资源列表页
const library_list = resolve => {
  require.ensure(['@/page/library_list.vue'], () => {
    resolve(require('@/page/library_list.vue'))
  })
}
const library_list_im = resolve => {
  require.ensure(['@/page/library_list_im.vue'], () => {
    resolve(require('@/page/library_list_im.vue'))
  })
}
const library_list_ws = resolve => {
  require.ensure(['@/page/library_list_ws.vue'], () => {
    resolve(require('@/page/library_list_ws.vue'))
  })
}
const library_list_asus = resolve => {
  require.ensure(['@/page/library_list_asus.vue'], () => {
    resolve(require('@/page/library_list_asus.vue'))
  })
}
const library_join_asus = resolve => {
  require.ensure(['@/page/library_join_asus.vue'], () => {
    resolve(require('@/page/library_join_asus.vue'))
  })
}
const library_list_cino= resolve => {
  require.ensure(['@/page/library_list_cino.vue'], () => {
    resolve(require('@/page/library_list_cino.vue'))
  })
}
const library_list_cino_im= resolve => {
  require.ensure(['@/page/library_list_cino_im.vue'], () => {
    resolve(require('@/page/library_list_cino_im.vue'))
  })
}
const library_list_cino_ws= resolve => {
  require.ensure(['@/page/library_list_cino_ws.vue'], () => {
    resolve(require('@/page/library_list_cino_ws.vue'))
  })
}
//5.资源详情页
const library_detail = resolve => {
  require.ensure(['@/page/library_detail.vue'], () => {
    resolve(require('@/page/library_detail.vue'))
  })
}
const library_detail_im = resolve => {
  require.ensure(['@/page/library_detail_im.vue'], () => {
    resolve(require('@/page/library_detail_im.vue'))
  })
}
const library_detail_ws = resolve => {
  require.ensure(['@/page/library_detail_ws.vue'], () => {
    resolve(require('@/page/library_detail_ws.vue'))
  })
}
const library_detail_sn = resolve => {
  require.ensure(['@/page/library_detail_sn.vue'], () => {
    resolve(require('@/page/library_detail_sn.vue'))
  })
}
const library_detail_asus = resolve => {
  require.ensure(['@/page/library_detail_asus.vue'], () => {
    resolve(require('@/page/library_detail_asus.vue'))
  })
}
const library_detail_cino = resolve => {
  require.ensure(['@/page/library_detail_cino.vue'], () => {
    resolve(require('@/page/library_detail_cino.vue'))
  })
}
const library_detail_cino_im = resolve => {
  require.ensure(['@/page/library_detail_cino_im.vue'], () => {
    resolve(require('@/page/library_detail_cino_im.vue'))
  })
}
const library_detail_cino_ws = resolve => {
  require.ensure(['@/page/library_detail_cino_ws.vue'], () => {
    resolve(require('@/page/library_detail_cino_ws.vue'))
  })
}
//6.资源操作成功页面
const library_success = resolve => {
  require.ensure(['@/page/library_success.vue'], () => {
    resolve(require('@/page/library_success.vue'))
  })
}
//7.设置页面
const setting = resolve => {
  require.ensure(['@/page/setting.vue'], () => {
    resolve(require('@/page/setting.vue'))
  })
}

Vue.use(Router)

export default new Router({
  routes: [

    {
      path: '/:lang/',
      name: 'index',
      component: index
    },
    {
      path: '/:lang/im',
      name: 'index_im',
      component: index_im
    },
    {
      path: '/:lang/ws',
      name: 'index_ws',
      component: index_ws
    },
    {
      path: '/:lang/sn',
      name: 'index_sn',
      component: index_sn
    },
    {
      path: '/:lang/asus',
      name: 'index_asus',
      component: index_asus
    },
    {
      path: '/:lang/cino',
      name: 'index_cino',
      component: index_cino
    },
    {
      path: '/:lang/cino_im',
      name: 'index_cino_im',
      component: index_cino_im
    },
    {
      path: '/:lang/cino_ws',
      name: 'index_cino_ws',
      component: index_cino_ws
    },
    {
      path: '/:lang/select',
      name: 'select',
      component: select
    },
    {
      path: '/:lang/select_sn',
      name: 'select_sn',
      component: select_sn
    },
    {
      path: '/:lang/select_im',
      name: 'select_im',
      component: select_im
    },
    {
      path: '/:lang/select_ws',
      name: 'select_ws',
      component: select_ws
    },
    {
      path: '/:lang/select_asus',
      name: 'select_asus',
      component: select_asus
    },
    {
      path: '/:lang/select_cino',
      name: 'select_cino',
      component: select_cino
    },
    {
      path: '/:lang/select_cino_im',
      name: 'select_cino_im',
      component: select_cino_im
    },
    {
      path: '/:lang/select_cino_ws',
      name: 'select_cino_ws',
      component: select_cino_ws
    },
    {
      path: '/:lang/library_group',
      name: 'library_group',
      component: library_group
    },
    {
      path: '/:lang/library_group_im',
      name: 'library_group_im',
      component: library_group_im
    },
    {
      path: '/:lang/library_group_ws',
      name: 'library_group_ws',
      component: library_group_ws
    },
    {
      path: '/:lang/library_group_cino',
      name: 'library_group_cino',
      component: library_group_cino
    },
    {
      path: '/:lang/library_group_asus',
      name: 'library_group_asus',
      component: library_group_asus
    },
    {
      path: '/:lang/library_group_cino_im',
      name: 'library_group_cino_im',
      component: library_group_cino_im
    },
    {
      path: '/:lang/library_group_cino_ws',
      name: 'library_group_cino_ws',
      component: library_group_cino_ws
    },
    {
      path: '/:lang/library_list',
      name: 'library_list',
      component: library_list
    },
    {
      path: '/:lang/library_list_asus',
      name: 'library_list_asus',
      component: library_list_asus
    },
    {
      path: '/:lang/library_list_im',
      name: 'library_list_im',
      component: library_list_im
    },
    {
      path: '/:lang/library_list_ws',
      name: 'library_list_ws',
      component: library_list_ws
    },
    {
      path: '/:lang/library_join_asus',
      name: 'library_join_asus',
      component: library_join_asus
    },
    {
      path: '/:lang/library_list_cino',
      name: 'library_list_cino',
      component: library_list_cino
    },
    {
      path: '/:lang/library_list_cino_im',
      name: 'library_list_cino_im',
      component: library_list_cino_im
    },
    {
      path: '/:lang/library_list_cino_ws',
      name: 'library_list_cino_ws',
      component: library_list_cino_ws
    },
    {
      path: '/:lang/library_detail',
      name: 'library_detail',
      component: library_detail
    },
    {
      path: '/:lang/library_detail_im',
      name: 'library_detail_im',
      component: library_detail_im
    },
    {
      path: '/:lang/library_detail_ws',
      name: 'library_detail_ws',
      component: library_detail_ws
    },
    {
      path: '/:lang/library_detail_sn',
      name: 'library_detail_sn',
      component: library_detail_sn
    },
    {
      path: '/:lang/library_detail_asus',
      name: 'library_detail_asus',
      component: library_detail_asus
    },
    {
      path: '/:lang/library_detail_cino',
      name: 'library_detail_cino',
      component: library_detail_cino
    },
    {
      path: '/:lang/library_detail_cino_im',
      name: 'library_detail_cino_im',
      component: library_detail_cino_im
    },
    {
      path: '/:lang/library_detail_cino_ws',
      name: 'library_detail_cino_ws',
      component: library_detail_cino_ws
    },
    {
      path: '/:lang/library_success',
      name: 'library_success',
      component: library_success
    },
    {
      path: '/:lang/setting',
      name: 'setting',
      component: setting
    },
    {
      path: '*',
      name: 'empty',
      component: empty
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js